import { AxiosPromise } from 'axios';

import xhr from './xhr';
import {
  Signin, ResponseSignin, Usuario, CadastroUsuario, UpdateUsuario, Permissao,
  ResultAplicacao,
} from '../@types/exports';
import store from '../store';

interface ResultIife {
  id?: string | number;
  params?: { [x: string]: string | number | undefined | any };
}

interface ResultIifeResult {
  nameUsuario: string;
  emailUsuario: string;
  nameRealm: string;
  servicoId: string;
}

const getRealmSelected = (data: ResultIife): ResultIifeResult => {
  const { realm } = store.getState();

  return {
    ...data,
    ...realm,
  };
};

// Immediately-Invoked Function Expression (IIFE)
// ((value: string) => console.log('IIFE', value))(getRealmSelected());

/**
 * Web Ticket
 */
const getWebTicket = (): AxiosPromise => xhr
  .get('/realm/client/webticket');

/**
 * LOGIN
 */
const login = (params: Signin): AxiosPromise<ResponseSignin> => xhr
  .post('/login', params, { headers: { Authorization: '' } });

const alterarSenhaProvisoria = (params: any): AxiosPromise => xhr
  .patch('/usuario', params);

const alterarSenha = (params: any, token: string): AxiosPromise => xhr
  .put('/forgot', params, { headers: { Authorization: token } });
/**
 *  Refresh Token
 */
const refreshToken = <A, B>(refreshTokenSend: A, clientId?: B): AxiosPromise => xhr
  .post('/login/refreshtoken', { refresh_token: refreshTokenSend, clientId });
/**
 * Usuários
 */
// const getUsuarios = (): AxiosPromise<Usuario[]> => (({ nameRealm }) => xhr
// .get(`/realm/mtrix/admin/user/${nameRealm}`))(getRealmSelected({}));
const getUsuarios = (): AxiosPromise<Usuario[]> => xhr
  .get('/realm/parceiros/user');

const getUserInfo = <T>(params: T): AxiosPromise => xhr.get('/login/user-info', { params });

const createUsuario = (params: CadastroUsuario): AxiosPromise => xhr
  .post('/realm/parceiros/user', params);

const updateUsuario = (id: string, params: UpdateUsuario): AxiosPromise => xhr
  .put(`/realm/parceiros/user/${id}`, params);

const getPermissaoPorUsuario = (usuarioId: string): AxiosPromise => (({ servicoId }) => xhr
  .get(`/realm/parceiros/linkroles/${servicoId}/${usuarioId}`))(getRealmSelected({}));

/**
 * Permissões = Roles
 */
// Get permissões
const getPermissoes = (): AxiosPromise<Permissao[]> => (({ servicoId }) => xhr
  .get(`/realm/parceiros/roles/${servicoId}`))(getRealmSelected({}));
// Cria Permissões
const createPermissao = (params: any): AxiosPromise => (({ servicoId: containerId }) => xhr
  .post('/realm/parceiros/roles/', { ...params, containerId }))(getRealmSelected({}));
// Deleta permissões
const deletePermissao = (roleName: string): AxiosPromise => (({ servicoId }) => xhr
  .delete(`/realm/parceiros/roles/${servicoId}/${roleName}`))(getRealmSelected({}));
/**
 * Aplicações
 */
const getAplicacoesDoUsuario = (): AxiosPromise<ResultAplicacao> => xhr
  .get('/realm/client');
/**
 * Aplicações = clientes
 */
const getAplicacoes = (): AxiosPromise<ResultAplicacao> => xhr
  .get('/realm/client/');

/**
 * SEND
 */
const enviarEmail = (params: any): AxiosPromise => xhr
  .post('/forgot', params);
/**
 * FORGOT = PASSWORD
 */
const forgotPassword = (messageForgot: any): AxiosPromise => xhr
  .post('/forgot', messageForgot);
/**
* CHANGE = PASSWORD
*/
const changePassword = (messageForgot: any, token: string): AxiosPromise => xhr
  .put('/forgot', messageForgot, { headers: { Authorization: token } });

const changePasswordUserAuthenticated = <T>(params: T): AxiosPromise => ((realm) => xhr
  .patch('/forgot/change-password', { ...params, ...realm }))(getRealmSelected({}));

const removerUsuario = (usuarioId: string): AxiosPromise => (() => xhr
  .delete(`/realm/parceiros/user/${usuarioId}`))();

const removerPermissoesUsuario = (usuarioId: string): AxiosPromise => (({ servicoId }) => xhr
  .delete(`/realm/parceiros/linkroles/${servicoId}/${usuarioId}`))(getRealmSelected({}));

const updatePermissao = (nomeOriginal: any, params: any): AxiosPromise => ((
  { nameRealm, servicoId: containerId },
) => xhr.put(`/realm/mtrix/admin/roles/${nameRealm}/${nomeOriginal}`, { ...params, containerId }))(getRealmSelected({}));

/**
 * Aceite dos termos
 */
const getTermos = (): AxiosPromise => xhr
  .get('/realm/parceiros/termos');

const setTermos = (): AxiosPromise => xhr
  .post('/realm/parceiros/termos');

/**
 *  Vinculo Permissão Aplicação
 */
const getPermissaoAplicacao = (): AxiosPromise => (({ servicoId }) => xhr
  .get(`/realm/parceiros/roleaux/all/${servicoId}`))(getRealmSelected({}));
/**
 * Busca URL com hash de sessão para implanta
 */
const buscaHashImplanta = (idAplicacao: any) => xhr
  .post(`/realm/parceiros/link/${idAplicacao}`);
export default {
  login,
  alterarSenhaProvisoria,
  alterarSenha,
  getAplicacoesDoUsuario,
  getAplicacoes,
  enviarEmail,
  getUsuarios,
  getUserInfo,
  createUsuario,
  updateUsuario,
  getPermissaoPorUsuario,
  getPermissoes,
  forgotPassword,
  changePassword,
  changePasswordUserAuthenticated,
  removerUsuario,
  removerPermissoesUsuario,
  getTermos,
  setTermos,
  getPermissaoAplicacao,
  createPermissao,
  deletePermissao,
  updatePermissao,
  buscaHashImplanta,
  refreshToken,
  getWebTicket,
};
